import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import {
  saveData,
  updateMaxMonthlyOrders,
  updatePhone,
  updatePlatform, updatePopover, updateSaving,
  updateWebsite,
  updateWebsiteInvalid
} from './state/platform_actions_creator';
import { PlatformState, cloneState } from './state/platform_state';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { DropDownOption } from '../../shared/models/dropdown_option';
import { WindowService } from '../../shared/services/window.service';
import { REDCRSS_EVENTS } from '../../shared/services/constants/redcross_evemts';
import { monthlyOrderOptions, platformOptions } from '../shared/constants';
import { FlowTrackingService } from '../shared/services/flow-tracking.service';
import { IAppState } from '../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Component({
  selector: 'yi-platform',
  template: require('./platform.component.html'),
  styles: [require('./platform.component.scss')]
})
export class PlatformComponent implements OnInit {

  popoverPlacement = this.windowService.isNarrowWindow() ? 'top' : 'right';
  @ViewChild('platformForm') platformForm: NgForm;
  @ViewChild('invalidWebsitePop') invalidWebsitePop: PopoverDirective;
  @ViewChild('invalidPlatformPop') invalidPlatformPop: PopoverDirective;
  public platformOptions = platformOptions;
  public monthlyOrderOptions = monthlyOrderOptions;
  private state: PlatformState;

  constructor(
    private store: Store<IAppState>,
    private redCrossService: AnalyticsTrackingProvider,
    private windowService: WindowService,
    private flowTrackingService: FlowTrackingService
  ) {
    this.store.select(state => state.app.signup.platform).subscribe((data: PlatformState) => {
      this.state = cloneState(data);
      if (this.state.popover) {
        this.showPopovers();
      } else {
        this.hidePopovers();
      }
    });
  }

  ngOnInit() {
    this.redCrossService.page(REDCRSS_EVENTS.VIEWED_B2B_PAGE, { pageCategory: 'Registration' });
    this.flowTrackingService.StepTwoStarted();
  }

  onSubmit(form) {
    if (form.valid && this.validatePlatform() && !this.state.website_invalid) {
      this.store.dispatch(updateSaving({saving: true}));
      this.store.dispatch(saveData());
    } else {
      if (this.platformForm.form.get('platform').invalid || !this.validatePlatform()) {
        this.invalidPlatformPop.show();
      }
      if (this.platformForm.form.get('website').invalid || this.state.website_invalid) {
        this.invalidWebsitePop.show();
      }
    }
  }

  platformChanged(option: DropDownOption<string>) {
    this.store.dispatch(updatePlatform({platform: option.value}));
  }

  websiteChanged(website) {
    this.store.dispatch(updateWebsite({website}));
    this.store.dispatch(updatePopover({popover: false}));
    this.store.dispatch(updateWebsiteInvalid({website_invalid: false}));
  }

  monthlyOrdersChanged(option: DropDownOption<string>) {
    this.store.dispatch(updateMaxMonthlyOrders({maxMonthlyOrders: option.value}));
  }

  phoneChanged(phone) {
    this.store.dispatch(updatePhone({phone}));
  }

  hidePopovers() {
    if (this.invalidWebsitePop && this.invalidPlatformPop) {
      this.invalidWebsitePop.hide();
      this.invalidPlatformPop.hide();
    }
  }

  showPopovers() {
    if (this.state.website_invalid) {
      this.invalidWebsitePop.show();
    } else {
      this.invalidWebsitePop.hide();
    }
  }

  private validatePlatform() {
    return this.isValidPlatform(this.state.platform);
  }

  private isValidPlatform(platform): boolean {
    return (platform && platform !== '' && platform !== 0);
  }
}
